import React, { forwardRef } from "react";

import { ChevronDown } from "lucide-react";
import { cn } from "src/shadcn/lib/utils";
import { Button } from "src/components/Button";

import type { BaseTriggerProps } from "./types";

/**
 * Extra props that Radix's Slot injects when the parent Trigger uses
 * `asChild` (aria-expanded, aria-haspopup, data-state, id, …).
 * We capture them with a rest-spread so they reach the DOM button.
 */
type TriggerButtonProps = BaseTriggerProps &
  Omit<React.ComponentProps<"button">, keyof BaseTriggerProps>;

const TriggerButton = forwardRef<HTMLButtonElement, TriggerButtonProps>(
  (
    {
      label,
      icon,
      buttonProps,
      disabled,
      isOpen,
      onClick,
      className,
      ...otherProps
    },
    ref
  ) => (
    <Button
      ref={ref}
      type="button"
      label={label}
      icon={icon}
      iconPosition="left"
      trailing={
        <ChevronDown
          aria-hidden="true"
          className={cn(
            "shrink-0 transition-transform duration-200",
            isOpen && "rotate-180"
          )}
        />
      }
      disabled={disabled}
      {...otherProps}
      {...buttonProps}
      onClick={onClick}
      className={cn(className, buttonProps?.className)}
    />
  )
);
TriggerButton.displayName = "Dropdown.TriggerButton";

export { TriggerButton };
